import { Service, ServiceAction, ServiceActionType } from '../types';
import { ServiceActionTypes } from '../constants';
import getActionMeta from './getActionMeta';

export default function actionMeta(
  service: Service,
  actionKey: string,
  typeOf: ServiceActionType = ServiceActionTypes.READ as ServiceActionType
) {
  if (!service || !service[typeOf]) {
    return null;
  }
  return getActionMeta(service[typeOf] as ServiceAction[], actionKey);
}
